import React from 'react';
import { graphql } from 'gatsby';
import { Hero } from '@/components/hero/hero';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { EventBlock } from '@/components/event-block/event-block';
import { Button, Metadata } from '@/components';

const NewsEventsCampaigns = () => {
  const { t } = useI18next();

  return (
    <>
      <Hero title={t('events.hero-title')} backgroundImage="/img/events-main.webp" />
      <div className="container-fluid container-fluid--custom">
        <div className="row">
          <div className="col-12 col-lg-4 p-4 bg-gray-200">
            <h2 className="mb-5">{t('events.left-title')}</h2>
            <EventBlock
              title={t('events.campaigns-event.10-title')}
              date={t('events.campaigns-event.10-date')}
              text={t('events.campaigns-event.10-body')}
              image="awareness-campaign-2024"
              imageLink="awareness-campaign-2024-button"
            />
            <EventBlock
              title={t('events.campaigns-event.9-title')}
              date={t('events.campaigns-event.9-date')}
              text={t('events.campaigns-event.9-body')}
              image="awareness-campaign"
              imageLink="awareness-campaign-button"
            />
            <EventBlock
              title={t('events.campaigns-event.8-title')}
              date={t('events.campaigns-event.8-date')}
              text={t('events.campaigns-event.8-body')}
              image="cataract-surgery"
              imageLink="cataract-surgery-button"
            />
            <EventBlock
              title={t('events.campaigns-event.1-title')}
              date={t('events.campaigns-event.1-date')}
              text={t('events.campaigns-event.1-body')}
              image="diabetic-retinopathy"
              link="https://www.marica.bg/plovdiv/zdraveopazvane/diabetnata-retinopatiq-e-sred-vodeshtite-prichini-za-slepota"
            />
            <EventBlock
              title={t('events.campaigns-event.2-title')}
              date={t('events.campaigns-event.2-date')}
              text={t('events.campaigns-event.2-body')}
              image="children-eye-exam"
              link="https://www.marica.bg/plovdiv/zdraveopazvane/bezplatni-profilaktichni-pregledi-za-deca-v-ochna-klinika-luksor"
            />
            <EventBlock
              title={t('events.campaigns-event.3-title')}
              date={t('events.campaigns-event.3-date')}
              text={t('events.campaigns-event.3-body')}
              image="national-screening-campaign"
            >
              <a
                href={
                  'https://velingrad.bg/main/blog/2021/05/10/%D0%BD%D0%B0-19-%D0%BC%D0%B0%D0%B9-%D1%89%D0%B5-%D1%81%D0%B5-%D0%B8%D0%B7%D0%B2%D1%8A%D1%80%D1%88%D0%B2%D0%B0%D1%82-%D0%B1%D0%B5%D0%B7%D0%BF%D0%BB%D0%B0%D1%82%D0%BD%D0%B8-%D0%BE%D1%87%D0%BD%D0%B8/'
                }
                rel="noreferrer nofollow"
                target="_blank"
              >
                <Button title={t('g.velingrad')} className={'text-uppercase shadow btn-success me-2'} />
              </a>
              <a href={'https://www.smolyan.bg/bg/news/view/4909'} rel="noreferrer nofollow" target="_blank">
                <Button title={t('g.smolyan')} className={'text-uppercase shadow btn-success'} />
              </a>
            </EventBlock>
            <EventBlock
              title={t('events.campaigns-event.4-title')}
              date={t('events.campaigns-event.4-date')}
              text={t('events.campaigns-event.4-body')}
              image="adv-eye-exam"
              link="https://www.zdrave.net/%D0%9D%D0%BE%D0%B2%D0%B8%D0%BD%D0%B8/%D0%91%D0%B5%D0%B7%D0%BF%D0%BB%D0%B0%D1%82%D0%BD%D0%B8-%D0%BE%D1%87%D0%BD%D0%B8-%D0%BF%D1%80%D0%B5%D0%B3%D0%BB%D0%B5%D0%B4%D0%B8-%D0%BE%D1%82-22-%D1%8E%D0%BD%D0%B8-%D0%B4%D0%BE-10-%D1%8E%D0%BB%D0%B8/n13592?fbclid=IwAR3HU6tTz30G0ywuVpsmh7Q1B_KMdFPiey_PKySBnIXa7gFPrphNDtUgfd8"
            />
            <EventBlock
              title={t('events.campaigns-event.5-title')}
              date={t('events.campaigns-event.5-date')}
              text={t('events.campaigns-event.5-body')}
              image="eye-exam-2019"
              imageLink="eye-exam-2019-modal"
            />
            <EventBlock
              title={t('events.campaigns-event.6-title')}
              date={t('events.campaigns-event.6-date')}
              text={t('events.campaigns-event.6-body')}
              image="pravo-na-zrenie"
              link="http://www.plovdiv.bg/%D0%BD%D0%B0%D0%B4-300-%D0%BF%D1%80%D0%B5%D0%B3%D0%BB%D0%B5%D0%B4%D0%B0%D0%BD%D0%B8-%D0%B7%D0%B0-%D0%BA%D0%B0%D1%82%D0%B0%D1%80%D0%B0%D0%BA%D1%82%D0%B0-%D0%B8-%D0%B3%D0%BB%D0%B0%D1%83%D0%BA%D0%BE/"
            />
            <EventBlock
              title={t('events.campaigns-event.7-title')}
              date={t('events.campaigns-event.7-date')}
              text={t('events.campaigns-event.7-body')}
              image="kid"
              link="https://www.facebook.com/ocolut.products/photos/a.1469563129937608.1073741828.1450715945155660/2027430040817578/?type=3&theater"
            />
          </div>
          <div className="col-12 col-lg-4 p-4">
            <h2 className="mb-5">{t('events.middle-title')}</h2>
            <EventBlock
              title={t('events.events-event.11-title')}
              date={t('events.events-event.11-date')}
              text={t('events.events-event.11-body')}
              image="aesthetic-expo"
              imageLink="aesthetic-expo-button"
            />
            <EventBlock
              title={t('events.events-event.10-title')}
              date={t('events.events-event.10-date')}
              text={t('events.events-event.10-body')}
              image="aesthetic-expo-2023"
              imageLink="aesthetic-expo-2023-button"
            />
            <EventBlock
              title={t('events.events-event.9-title')}
              date={t('events.events-event.9-date')}
              text={t('events.events-event.9-body')}
              image="intraocular-lenses"
              imageLink="intraocular-lenses-button"
            />
            <EventBlock
              title={t('events.events-event.8-title')}
              date={t('events.events-event.8-date')}
              text={t('events.events-event.8-body')}
              image="educational-course-ophthalmology-luxor"
              imageLink="еylea-еducational-course"
            />
            <EventBlock
              title={t('events.events-event.1-title')}
              date={t('events.events-event.1-date')}
              text={t('events.events-event.1-body')}
              image="drtaskov-presents-new-lense"
              imageLink="ophthalmologists-colleges"
            />
            <EventBlock
              title={t('events.events-event.2-title')}
              date={t('events.events-event.2-date')}
              text={t('events.events-event.2-body')}
              image="honorary-citizenship"
              link="https://trafficnews.bg/plovdiv/udostoiha-oftalmologa-d-r-dimitar-taskov-pocheten-222077/?fbclid=IwAR24R7762qVUZd1W4wWi_vryA1nIJ2ec2ZYMPD-zFxlgxkMw0-ivSsNFAw8"
            />
            <EventBlock
              title={t('events.events-event.3-title')}
              date={t('events.events-event.3-date')}
              text={t('events.events-event.3-body')}
              image="eye-health-talk"
              imageLink="keep-eyes-safe-talk"
            />
            <EventBlock
              title={t('events.events-event.4-title')}
              date={t('events.events-event.4-date')}
              text={t('events.events-event.4-body')}
              image="dtaskov"
              imageLink="/img/certificates/dtaskov/BASA.webp"
            />
            <EventBlock
              title={t('events.events-event.5-title')}
              date={t('events.events-event.5-date')}
              text={t('events.events-event.5-body')}
              image="7"
              link="http://www.gustonews.bg/?page=article&instanceID=59465"
            />
            <EventBlock
              title={t('events.events-event.6-title')}
              date={t('events.events-event.6-date')}
              text={t('events.events-event.6-body')}
              image="glaucoma-treatment"
              link="https://www.luxorclinic.com/glaucoma/"
            />
            <EventBlock
              title={t('events.events-event.7-title')}
              date={t('events.events-event.7-date')}
              text={t('events.events-event.7-body')}
              image="top-oftamolozi"
              link="https://dariknews.bg/regioni/stara-zagora/top-oftalmolozi-ot-plovdiv-i-stara-zagora-predavat-umeniqta-si-na-mladi-kolegi-1618471"
            />
          </div>
          <div className="col-12 col-lg-4 p-4 bg-gray-200">
            <h2 className="mb-5">{t('events.right-title')}</h2>
            <EventBlock
              title={t('events.news-event.9-title')}
              date={t('events.news-event.9-date')}
              text={t('events.news-event.9-body')}
              image="refractive-surgery"
              imageLink="refractive-surgery-button"
            />
            <EventBlock
              title={t('events.news-event.1-title')}
              date={t('events.news-event.1-date')}
              text={t('events.news-event.1-body')}
              image="dr-todor-taskov"
              imageLink="dr-todor-taskov2"
            />
            <EventBlock
              title={t('events.news-event.2-title')}
              date={t('events.news-event.2-date')}
              text={t('events.news-event.2-body')}
              image="taskov-doctors"
              link="https://www.capital.bg/politika_i_ikonomika/zdraveopazvane/2021/12/29/4286191_d-r_georgi_taskov_oftalmolog_v_oftalmologiiata/"
            />
            <EventBlock
              title={t('events.news-event.3-title')}
              date={t('events.news-event.3-date')}
              text={t('events.news-event.3-body')}
              image="dtaskov-magazine-cover"
              imageLink="36.6-interview"
            />
            <EventBlock
              title={t('events.news-event.4-title')}
              date={t('events.news-event.4-date')}
              text={t('events.news-event.4-body')}
              image="age-related-cataract-interview"
              link="https://bnr.bg/horizont/post/101305640/slanceto-moje-da-prichini-katarakta"
            />
            <EventBlock
              title={t('events.news-event.5-title')}
              date={t('events.news-event.5-date')}
              text={t('events.news-event.5-body')}
              image="health-spirit"
              videoLink="FaQv8J2BfOw"
            />
            <EventBlock
              title={t('events.news-event.6-title')}
              date={t('events.news-event.6-date')}
              text={t('events.news-event.6-body')}
              image="laser-vision"
              link="https://trafficnews.bg/zdravi-i-krasivi/d-r-taskov-i-lekarite-se-podlagat-lazerna-korektsiia-109723/"
            />
            <EventBlock
              title={t('events.news-event.7-title')}
              date={t('events.news-event.7-date')}
              text={t('events.news-event.7-body')}
              image="medii-obshtestvo"
              link="http://news.bnt.bg/bg/a/utvrdeni-lekari-i-zhurnalisti-se-sbrakha-na-natsionalna-sreshcha-v-kurorta-albena"
            />
            <EventBlock
              title={t('events.news-event.8-title')}
              date={t('events.news-event.8-date')}
              text={t('events.news-event.8-body')}
              image="dr-taskov-btv"
              link="http://www.btv.bg/video/shows/duhat-na-zdraveto/videos/savremennoto-lechenie-i-diagnostikata-na-ochnite-zabolyavaniya.html"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const Head = (props) => {
  const { data, pageContext } = props;
  const locale = JSON.parse(data?.locales?.edges?.[0]?.node?.data || null);

  return (
    <Metadata
      title={locale?.events['title']}
      description={locale?.events['description']}
      fallbackTitle={locale?.g.title}
      pageContext={pageContext}
      locale={locale}
    />
  );
};

export default NewsEventsCampaigns;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
